import {
  Container,
  Stack,
  List,
  ListItem,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Text } from "../components/Text";
import { Parentheses } from "../components/Parentheses";

export const Technology = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Stack>
      <Stack
        justifyContent="center"
        sx={{
          backgroundImage: isMobile
            ? "url(/images/technology-kv_sp.png)"
            : "url(/images/technology-kv.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: isMobile ? 200 : 320,
        }}
      >
        <Container>
          <Text variant="h1" fontSize={40} color="primary">
            技術紹介
          </Text>
          <Text
            variant="h2"
            marginTop={1}
            color="primary"
            sx={{
              fontSize: isMobile ? "22px !important" : 28,
            }}
          >
            Technology Introductionn
          </Text>
        </Container>
      </Stack>
      <Stack id="1">
        <Container>
          <Parentheses>
            <Stack>
              <Text variant="h3" color="primary" lineHeight={1.5}>
                自律的に複製可能なベクター
              </Text>
              <Text marginTop={2} lineHeight={2}>
                MycoGenomeのゲノム編集技術では、細胞内で自律的に複製できるベクターを使用します。これにより、遺伝子改変後に不要なDNAを細胞から取り除くことが可能になり、非遺伝子組換え型の微生物を作製できます。
              </Text>
              <Stack
                sx={{
                  background: "#006400",
                  color: "#fff",
                  width: "fit-content",
                  lineHeight: 1,
                  padding: "5px 14px",
                  marginTop: 2.6,
                }}
              >
                特徴
              </Stack>
              <List>
                {[
                  "細胞への遺伝子導入効率を大幅に向上",
                  "外来遺伝子導入後、不要なベクターを細胞内から完全除去",
                  "外来DNAを含まない自然な微生物改良が可能",
                  "産業利用に適した安全性の高い手法",
                ].map((text, index) => {
                  return (
                    <ListItem
                      key={index}
                      sx={{
                        padding: 0,
                        "&::before": {
                          content: "'⚫︎'",
                          color: "#ffbd00",
                          paddingRight: 1,
                        },
                      }}
                    >
                      <Text lineHeight={1.7} fontWeight="bold">
                        {text}
                      </Text>
                    </ListItem>
                  );
                })}
              </List>
            </Stack>
          </Parentheses>
        </Container>
      </Stack>
      <Stack
        id="2"
        sx={{
          background: "#f6f6f6",
        }}
      >
        <Container>
          <Parentheses>
            <Stack>
              <Text variant="h3" color="primary" lineHeight={1.5}>
                国産のCRISPRフリーゲノム 編集ツール
              </Text>
              <Text marginTop={2} lineHeight={2}>
                従来のCRISPR/Cas9を用いたゲノム編集には、高額なライセンス費用や細胞毒性の課題がありました。MycoGenomeの「MycoEdita」は、CRISPRを使用せずに高精度なゲノム編集を可能にした純国産技術です。
              </Text>
              <Stack
                sx={{
                  background: "#006400",
                  color: "#fff",
                  width: "fit-content",
                  lineHeight: 1,
                  padding: "5px 14px",
                  marginTop: 2.6,
                }}
              >
                特徴
              </Stack>
              <List>
                {[
                  "CRISPR/Cas9に依存しないため、特許リスクなし",
                  "細胞毒性の影響を受けにくく、微生物に最適",
                  "産業利用に適したコストパフォーマンス",
                ].map((text, index) => {
                  return (
                    <ListItem
                      key={index}
                      sx={{
                        padding: 0,
                        "&::before": {
                          content: "'⚫︎'",
                          color: "#ffbd00",
                          paddingRight: 1,
                        },
                      }}
                    >
                      <Text lineHeight={1.7} fontWeight="bold">
                        {text}
                      </Text>
                    </ListItem>
                  );
                })}
              </List>
            </Stack>
          </Parentheses>
        </Container>
      </Stack>
      <Stack id="3">
        <Container>
          <Parentheses>
            <Stack>
              <Text variant="h3" color="primary" lineHeight={1.5}>
                微生物特化型のゲノム編集手法
              </Text>
              <Text marginTop={2} lineHeight={2}>
                微生物（特に真菌）へのゲノム編集は、動植物とは異なる技術が求められます。MycoGenomeでは、真菌の特性を活かした独自の編
                集手法を開発し、より効率的な遺伝子改変を可能にしました。
              </Text>
              <Stack
                sx={{
                  background: "#006400",
                  color: "#fff",
                  width: "fit-content",
                  lineHeight: 1,
                  padding: "5px 14px",
                  marginTop: 2.6,
                }}
              >
                特徴
              </Stack>
              <List>
                {[
                  "真菌に特化した編集ツールを開発",
                  "産業利用しやすい高精度な遺伝子改変",
                  "品種改良のスピードを飛躍的に向上",
                ].map((text, index) => {
                  return (
                    <ListItem
                      key={index}
                      sx={{
                        padding: 0,
                        "&::before": {
                          content: "'⚫︎'",
                          color: "#ffbd00",
                          paddingRight: 1,
                        },
                      }}
                    >
                      <Text lineHeight={1.7} fontWeight="bold">
                        {text}
                      </Text>
                    </ListItem>
                  );
                })}
              </List>
            </Stack>
          </Parentheses>
        </Container>
      </Stack>
      <Stack
        id="4"
        sx={{
          background: "#f6f6f6",
        }}
      >
        <Container>
          <Parentheses>
            <Stack>
              <Text variant="h3" color="primary" lineHeight={1.5}>
                無性的なゲノム交雑の促進
              </Text>
              <Text marginTop={2} lineHeight={2}>
                多くの真菌は有性生殖による通常の交雑が難しいとされています。MycoGenomeでは、独自の技術を用いて、無性的なゲノム交雑を促進する技術を開発し、より多様な微生物改良を可能にしています。
              </Text>
              <Stack
                sx={{
                  background: "#006400",
                  color: "#fff",
                  width: "fit-content",
                  lineHeight: 1,
                  padding: "5px 14px",
                  marginTop: 2.6,
                }}
              >
                特徴
              </Stack>
              <List>
                {[
                  "無性生殖の微生物でも交雑を可能に",
                  "新たな機能を持つ微生物の開発が可能",
                  "有性生殖と同様にゲノムレベルでの改変が可能",
                  "品種改良の選択肢を拡大",
                ].map((text, index) => {
                  return (
                    <ListItem
                      key={index}
                      sx={{
                        padding: 0,
                        "&::before": {
                          content: "'⚫︎'",
                          color: "#ffbd00",
                          paddingRight: 1,
                        },
                      }}
                    >
                      <Text lineHeight={1.7} fontWeight="bold">
                        {text}
                      </Text>
                    </ListItem>
                  );
                })}
              </List>
            </Stack>
          </Parentheses>
        </Container>
      </Stack>
    </Stack>
  );
};
